import axios from "axios";
import t from "./translate";
import { LOCAL_STORAGE_EMAIL } from "../components/Profile/constants";
import { logger } from "./logger";

const AXIOS_TIMEOUT = parseInt(t("GPC_TIMEOUT"), 10); // 10 sec

const NOT_COMPLETED_ASSESSMENT_CAMPAIGN_ID = t(
  "NOT_COMPLETED_ASSESSMENT_CAMPAIGN_ID"
); // 'US_CLINIC_ELIGIBLE_2024'

export const sendDataToGpc = () => {
  const email = window.localStorage.getItem(LOCAL_STORAGE_EMAIL);

  if (!email) {
    return null;
  }

  return axios({
    timeout: AXIOS_TIMEOUT,
    method: "patch",
    url: `https://api1.${window.ww.envSubdomain}weightwatchers.com/preferences/v4/public/preferences`,
    params: {
      market: "en-US",
      channel: "email"
    },
    data: {
      preferences: [
        {
          id: 1,
          optin: 1
        },
        {
          id: 25,
          optin: 1
        }
      ],
      campaign: NOT_COMPLETED_ASSESSMENT_CAMPAIGN_ID,
      ssid: "DIG",
      email
    }
  });
};

export const sendDataToGpcEli = () => {
  const email = window.localStorage.getItem(LOCAL_STORAGE_EMAIL);

  if (!email) {
    return;
  }

  axios({
    timeout: AXIOS_TIMEOUT,
    method: "patch",
    url: `https://api1.${window.ww.envSubdomain}weightwatchers.com/preferences/v4/public/preferences`,
    params: {
      market: "en-US",
      channel: "email"
    },
    data: {
      preferences: [
        {
          id: 1,
          optin: 1
        },
        {
          id: 25,
          optin: 1
        }
      ],
      campaign: NOT_COMPLETED_ASSESSMENT_CAMPAIGN_ID,
      ssid: "DIG",
      email
    }
  }).catch(error => {
    logger("Error sending data to GPC", {
      level: "error",
      customAttributes: { error }
    });
  });
};
